export default "__VITE_ASSET__a8c0138b__"